import {Component, DoCheck, Input, OnDestroy} from '@angular/core';
import {ComandoVista} from '../ai-chat-vista';

const formatoSecondi = new Intl.NumberFormat('it-IT', {minimumFractionDigits: 1, maximumFractionDigits: 1});

/** Feature 159: comandi MCP di una risposta, come riepilogo compatto: «Comandi in esecuzione · N di M» mentre
 * almeno uno è in corso, poi «N comandi eseguiti · X s». La lista si apre solo al clic (aprirla da sola durante
 * l'esecuzione la faceva apparire e sparire subito). */
@Component({
  selector: 'app-ai-chat-comandi',
  templateUrl: './ai-chat-comandi.component.html',
  styleUrls: ['./ai-chat-comandi.component.scss'],
  standalone: false
})
export class AiChatComandiComponent implements DoCheck, OnDestroy {
  @Input() comandi: ComandoVista[] = [];
  espanso = false;
  adesso = Date.now();
  private timer?: ReturnType<typeof setInterval>;

  get inEsecuzione(): boolean {
    return this.comandi.some(c => c.inCorso);
  }

  get completati(): number {
    return this.comandi.filter(c => !c.inCorso).length;
  }

  get conErrore(): number {
    return this.comandi.filter(c => !c.inCorso && c.esito === 'errore').length;
  }

  get inCorsoTesto(): string {
    return `Comandi in esecuzione · ${this.completati} di ${this.comandi.length}`;
  }

  get riepilogo(): string {
    const n = this.comandi.length;
    const totale = this.comandi.reduce((somma, c) => somma + c.durataMs, 0);
    const errori = this.conErrore ? `, ${this.conErrore} con errore` : '';
    return `${n} ${n === 1 ? 'comando eseguito' : 'comandi eseguiti'}${errori} · ${secondi(totale)}`;
  }

  // Il timer della durata «in corso» gira solo finché c'è un comando aperto.
  ngDoCheck() {
    const serve = this.inEsecuzione;
    if (serve && !this.timer) this.timer = setInterval(() => this.adesso = Date.now(), 250);
    if (!serve && this.timer) this.fermaTimer();
  }

  ngOnDestroy() {
    this.fermaTimer();
  }

  durata(comando: ComandoVista): string {
    return secondi(comando.inCorso ? this.adesso - comando.avviatoIl : comando.durataMs);
  }

  codice(comando: ComandoVista): string {
    return [comando.nome, ...comando.parametri.map(p => `${p.nome}: ${p.valore}`)].join(' · ');
  }

  righe(comando: ComandoVista): string {
    if (comando.righe == null) return '';
    return comando.righe === 1 ? ' · 1 riga' : ` · ${comando.righe} righe`;
  }

  private fermaTimer() {
    clearInterval(this.timer);
    this.timer = undefined;
  }
}

function secondi(ms: number): string {
  return `${formatoSecondi.format(Math.max(0, ms) / 1000)} s`;
}
